import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {ANCHOR_ICON_SIZE} from "@khan/guide-core";

import {PopoverGuideIcon} from "../../icons/popover-guide-icon.tsx";

interface Props {
    /**
     * Specifies which Khanmigo avatar to display for the button icon.
     */
    swagId?: string;
    /**
     * If true, the icon button will reflect a different state.
     */
    isGuideOffline?: boolean;
    /**
     * A callback that is triggered when the opener is clicked.
     */
    onClick: () => void;
}

/**
 * Renders a button used to open the Khanmigo chat window.
 */
export const GuideSidebarOpener = (props: Props) => {
    const {swagId = "default", isGuideOffline = false, onClick} = props;

    return (
        <>
            <Clickable
                aria-label={t`Open Khanmigo chat window`}
                style={styles.khanmigoSidebarToggle}
                onClick={onClick}
                testId="open-chat-bot-button"
            >
                {() => (
                    <View style={styles.button}>
                        <PopoverGuideIcon
                            id={swagId}
                            isOffline={isGuideOffline}
                            title={t`Open Khanmigo`}
                        />
                    </View>
                )}
            </Clickable>
        </>
    );
};

const styles = StyleSheet.create({
    button: {
        justifyContent: "center",
        alignItems: "center",
        height: ANCHOR_ICON_SIZE,
        width: ANCHOR_ICON_SIZE,
    },
    // If we don't style this, the focus ring is square!  Which looks weird.
    khanmigoSidebarToggle: {
        borderRadius: ANCHOR_ICON_SIZE / 2,
        overflow: "hidden",
        height: ANCHOR_ICON_SIZE,
        width: ANCHOR_ICON_SIZE,
    },
});
